import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

/**
 * Renders its children only for users with the `canViewAmounts` capability; otherwise
 * redirects to the dashboard. Defense-in-depth for amount-only screens (the tariff
 * grid + PR overview) — the nav already hides them and the API redacts amounts, but
 * this stops a user without the capability from reaching them by typing the URL.
 * Assumes it sits inside ProtectedRoute (the user is already authenticated).
 */
export function AmountGuard({ children }: { children: ReactNode }) {
  const { canViewAmounts } = useAuth();
  if (!canViewAmounts) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
